import ip from "./ip";
import port from "./port";

// TODO: use `new URL(str)` to get port, host address, etc.
export default function ipPort(str: string): string {
  if (str === "") {
    return "Address should not be empty.";
  }

  const idx = str.lastIndexOf(":");
  if (idx < 0) {
    return "Address should have a port. Examples: :443 | :5000";
  }

  let ipStr = str.substring(0, idx);
  if (ipStr.indexOf("[") === 0 && ipStr.indexOf("]") === ipStr.length - 1) {
    ipStr = ipStr.substring(1, ipStr.length - 1);
  }

  const ipError = ip(ipStr);
  if (ipError) {
    return "Address should have a valid ip address. Example: 127.0.0.1";
  }

  const portStr = str.substring(idx + 1);
  const portError = port(portStr);
  if (portError) {
    return "Address should have a valid port. Example: 443";
  }

  return "";
}
